import apiClient from "../../axios/apiClient";

export const getHospitalizationTypeList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_HOSPITALIZATIONTYPELIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Hospitalization-Type`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_HOSPITALIZATIONTYPELIST_FULFILLED",
        payload: response.data?.data,
        count: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_HOSPITALIZATIONTYPELIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveHospitalizationTypeData = (token, data) => async (dispatch) => {
    try {
      console.log('token, data', token, data);
      dispatch({ type: "ADD_HOSPITALIZATIONTYPE_PENDING" });
  
      const response = await apiClient.post(
        `/api/admin/v1/Add-Hospitalization-Type`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_HOSPITALIZATIONTYPE_FULFILLED", payload: response.data });
    } catch (error) {
      //console.log(error.response.data);
      dispatch({ type: "ADD_HOSPITALIZATIONTYPE_REJECTED", payload: error.response });
    }
  };
  

  export const getHospitalizationTypeListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_HOSPITALIZATIONTYPELISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Hospitalization-Type/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_HOSPITALIZATIONTYPELISTBYID_FULFILLED",
        payload: response.data?.data,
        stateCount: response.data?.count,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_HOSPITALIZATIONTYPELISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateHospitalizationTypeData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "UPDATE_HOSPITALIZATIONTYPE_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-Hospitalization-Type/${id}`, // Endpoint URL with vehicle ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_HOSPITALIZATIONTYPE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_HOSPITALIZATIONTYPE_REJECTED", payload: error.response });
  }
};


export const updateHospitalizationTypeStatusData = (token, id, status) => async (dispatch) => {
  try {
    //console.log('token, data', token, data);
    dispatch({ type: "UPDATE_HOSPITALIZATIONTYPE_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.post(
      `/api/admin/v1/Update-Hospitalization-Type-Status/${id}`, // Endpoint URL with vehicle ID
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_HOSPITALIZATIONTYPE_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_HOSPITALIZATIONTYPE_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteHospitalizationTypeData = (token, id) => async (dispatch) => {
  try {
    console.log('token, id', token, id);
    dispatch({ type: "DELETE_HOSPITALIZATIONTYPE_PENDING" });

    const response = await apiClient.delete(
      `/api/admin/v1/Delete-Hospitalization-Type/${id}`, // Endpoint URL with vehicle ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_HOSPITALIZATIONTYPE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_HOSPITALIZATIONTYPE_REJECTED", payload: error.response });
  }
};